module.exports = __webpack_public_path__ + "img/the-weekend-2024.de4c6952.jpg";